var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_content"},[_c('div',{staticClass:"banner_content_left"},[_c('div',{staticClass:"banner_content_left_title"},[_vm._v(_vm._s(_vm.returnTitle()))])]),_c('div',{staticClass:"banner_content_img",style:(`background-image:url(${_vm.returnImage()})`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }